///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { createAction, props } from '@ngrx/store';
import { CustomerDTO } from '../../generated/shared-types.model';

export const createCustomer = createAction('[CustomerConfig] Create Customer', props<{ newCustomer: CustomerDTO }>());

export const deleteCustomer = createAction('[CustomerConfig] Delete Customer', props<{ id: number }>());

export const editCustomer = createAction('[CustomerConfig] Edit Customer', props<{ updatedCustomer: CustomerDTO }>());

export const blockCustomer = createAction('[CustomerConfig] No Operation Action', props<{ id: number }>());
